import { AjaxRequest } from "../../utils/ajax-request.js";

export const Favorite = {
    selectors: {
        //favoriteSelectors: Array.prototype.slice.call(document.querySelectorAll('.js-favorite')), // document.querySelector('.js-favorite'),
        favoriteCounterSelector: document.querySelector('.js-favoritecounter'),
		favoritePopupSelector: document.querySelector('.js-favoritepopup'),
    },

    init: function () {
        let self = this;
		self.selectors.favoriteSelectors = Array.prototype.slice.call(document.querySelectorAll('.js-favorite'));
		if (this.selectors.favoriteCounterSelector !== null && this.selectors.favoritePopupSelector !== null) {
			self.clickEvent(self.selectors.favoriteSelectors);
		}
	},

    clickEvent: function (_selectors) {
        let self = this;

        if (_selectors) {
			_selectors.forEach((selector) => {
				selector.addEventListener('click', function(e) {
					e.preventDefault();

					// add to favorite
					if (selector.dataset.type === 'add') {
						self.addToFavorite(selector);
						// return because type changed to remove so it
						// would continue to remove after add :D
						return;
					}
					// remove from favorite
					if (selector.dataset.type === 'remove') {
						self.removeFromFavorite(selector);
					}
				});
			});
        }
    },

    addToFavorite: function (_selector) {
        let self = this;

        // add classes for heart icon
        self.selectorClasses(_selector, 'add');

        // increment counter in favorite
        self.changeFavoriteCount('increment');

        // hit URL for add if user is logged in
		self.hitUrl(_selector.dataset)
    },

    removeFromFavorite: function (_selector) {
        let self = this;

        // decrement counter in favorite
        self.changeFavoriteCount('decrement');

        // remove classes for heart icon
        self.selectorClasses(_selector, 'remove');

        // hit URL for remove if user is logged in
		// hit URL for add if user is logged in
		self.hitUrl(_selector.dataset)
    },

    hitUrl: function (_dataset) {

		let self = this;

		AjaxRequest.create(_dataset.url + '?type=' + _dataset.type + '&id=' + _dataset.id + '&object=' + _dataset.object)
			.then((result) => {
				if (! result.success) {
					alert(result.message);
				}
				self.changeFavoritePopupText(result.popup);
			})
			.catch((err) => AjaxRequest.handleError(err));

    },

    changeFavoriteCount: function (_type) {
        let self = this;

        let number = self.selectors.favoriteCounterSelector.innerHTML;
        if (_type === 'increment') {
            number++;
        }
        if (_type === 'decrement') {
            number--;
        }
        self.selectors.favoriteCounterSelector.innerHTML = number;
    },

	changeFavoritePopupText: function (_text) {
		let self = this;

		self.selectors.favoritePopupSelector.innerHTML = _text;
	},

    selectorClasses: function (_selector, _type) {
        let self = this;

        if (_type === 'add') {
			self.selectors.favoriteSelectors.forEach((selector) => {
				if (selector.dataset.id === _selector.dataset.id && selector.dataset.type === 'add') {
					selector.classList.add('u-hidden');
				}
				if (selector.dataset.id === _selector.dataset.id && selector.dataset.type === 'remove') {
					selector.classList.add('is-favorite');
					selector.classList.remove('u-hidden');
				}
			});
        }
        if (_type === 'remove') {
			self.selectors.favoriteSelectors.forEach((selector) => {
				if (selector.dataset.id === _selector.dataset.id && selector.dataset.type === 'add') {
					selector.classList.remove('is-favorite');
					selector.classList.remove('u-hidden');
				}
				if (selector.dataset.id === _selector.dataset.id && selector.dataset.type === 'remove') {
					selector.classList.add('u-hidden');
				}
			});
        }
    },
};

window.Favorite = Favorite;
Favorite.init();
